import React, { Component } from 'react';
import { withRouter } from "react-router-dom";

import Paper from 'material-ui/Paper';
import Grid from 'material-ui/Grid';
import Card, { CardContent, CardMedia } from 'material-ui/Card';

import Typography from 'material-ui/Typography';

import getImage from '../imageService';

class DeviceCard extends Component {
  render() {
    const device = this.props.device;
    const image = getImage(device.id);

    return (
      <Grid item xs={12} sm={6} md={4} lg={3} className='deviceCard'>
        <Paper onClick={this.visitDevicePage}>

          <Card>
            <CardMedia
              image={image}
              style={{height: '200px'}}
            />
            <CardContent className='deviceHeading'>
              <Typography variant="body2" component="h2">
                {device.name}
              </Typography>
            </CardContent>
          </Card>

        </Paper>
      </Grid>
    )
  }

  visitDevicePage = () => {
    this.props.history.push(`/aparati/${this.props.device.id}`);
  }
}

export default withRouter(DeviceCard);



// WEBPACK FOOTER //
// ./src/components/DeviceCard.js